import { html, svg } from "lit";

import { customElement, property, state } from "lit/decorators.js";

import { SignalElement, inject } from "ui-common/di";
import type { IAuthState } from "ui-common/services/auth/types";
import { getAssetUrl } from "helpers/assetHelpers";

import { styles } from "./user-avatar.css";

import { t } from "../../translations/i18n";

@customElement("user-avatar")
export class UserAvatar extends SignalElement {
  static override styles = styles;

  @inject<IAuthState>("authState")
  private authState!: IAuthState;

  @property({ type: String })
  size: "small" | "medium" | "large" = "medium";

  @property({ type: String })
  alt?: string;

  @state()
  private imageError = false;

  private getSizeValue(): string {
    switch (this.size) {
      case "small":
        return "32px";
      case "medium":
        return "64px";
      case "large":
        return "4.5rem";
      default:
        return "64px";
    }
  }

  private handleImageError = () => {
    this.imageError = true;
  };

  private renderFallback() {
    const sizeValue = this.getSizeValue();

    return svg`
      <svg width="${sizeValue}" height="${sizeValue}" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="50" fill="#e5e7eb"/>
        <circle cx="50" cy="35" r="15" fill="#9ca3af"/>
        <ellipse cx="50" cy="75" rx="25" ry="15" fill="#9ca3af"/>
      </svg>
    `;
  }

  override render() {
    const avatarUrl = this.authState.currentUser.get()?.avatarUrl;
    const src = getAssetUrl(avatarUrl);
    const altText = this.alt || t("user.userAvatar");
    const sizeValue = this.getSizeValue();

    if (!src || this.imageError) {
      return html` <div style="width: ${sizeValue}; height: ${sizeValue};">${this.renderFallback()}</div> `;
    }

    return html`
      <div style="width: ${sizeValue}; height: ${sizeValue};">
        <img src=${src} alt=${altText} @error=${this.handleImageError} />
      </div>
    `;
  }
}
